// NOTE: This file is only used if the add-on price is shown for the options. For example, if it says:
//
//       Max Solar 12V (+ $200)
//
//       That isn't correct since we store a quantity based on the width/length. This file will update those values
//       to be the price for each * the quantity.

function waitForGpoInputs(callback, timeout = 10000, interval = 100) {
  const start = Date.now();

  const check = () => {
    const inputs = document.querySelectorAll("input[gpo-data-variant-id][gpo-data-product-handle]");
    if (inputs.length > 0) {
      callback(inputs);
    } else if (Date.now() - start < timeout) {
      setTimeout(check, interval);
    } else {
      console.warn("GPO inputs not found within timeout.");
    }
  };

  check();
}

function applyGpoPriceLabels(inputs) {
  const inputArray = Array.from(inputs);

  const handleMap = {};

  inputArray.forEach(input => {
    const handle = input.getAttribute("gpo-data-product-handle");
    if (!handleMap[handle]) handleMap[handle] = [];
    handleMap[handle].push(input);
  });

  Object.entries(handleMap).forEach(([handle, inputs]) => {
    fetch(`/products/${handle}.js`)
      .then(res => res.json())
      .then(product => {
        const variantMap = {};
        product.variants.forEach(variant => {
          variantMap[variant.id] = parseFloat(variant.price);
        });

        inputs.forEach(input => {
          const variantId = parseInt(input.getAttribute("gpo-data-variant-id"), 10);
          const quantity = parseInt(input.getAttribute("data-quantity") || "1", 10);
          const priceInCents = variantMap[variantId];

          if (isNaN(priceInCents) || isNaN(quantity)) return;

          const unitPrice = priceInCents / 100;
          const totalPrice = unitPrice * quantity;
          const formatted = `$${totalPrice.toLocaleString(undefined, {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
          })}`;

          const inputId = input.getAttribute("id");
          const label = document.querySelector(`label[for="${inputId}"]`);
          const span = label?.querySelector(".addOn");

          if (span) {
            span.textContent = `(+ ${formatted})`;
          }
        });
      })
      .catch(err => {
        console.warn(`Failed to load product ${handle}:`, err);
      });
  });
}

document.addEventListener("DOMContentLoaded", () => {
  waitForGpoInputs(applyGpoPriceLabels);
});
